// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"emptyList_2Gfh1","screenTitle":"screenTitle_17fE2","backBtn":"backBtn_1u6Nk","emptyDescription":"emptyDescription_5HW23"};